import { useMemo, useState } from "react";
import { HeartPulse } from "lucide-react";
import { ToolLayout, TwoCol } from "@/components/tools/ToolLayout";
import { SectionCard, Field, MoneyInput, SliderRow, Segmented, StatCard, InfoRow, compactINR } from "@/components/tools/kit";
import { healthCover } from "@/lib/calculators";

export default function HealthInsurance() {
  const [cityTier, setTier] = useState("tier1");
  const [familyMembers, setFam] = useState(3);
  const [eldestAge, setAge] = useState(40);
  const [existingCover, setExisting] = useState(500000);
  const r = useMemo(() => healthCover({ cityTier, familyMembers, eldestAge, existingCover }), [cityTier, familyMembers, eldestAge, existingCover]);
  return (
    <ToolLayout title="Health Insurance Calculator" subtitle="Right medical cover for your family & city" icon={HeartPulse} accent="#D96B43">
      <TwoCol
        left={
          <SectionCard title="Your family">
            <div className="space-y-5">
              <Field label="City tier">
                <Segmented testid="hi-tier" value={cityTier} onChange={setTier} layoutId="hi-tier-pill"
                  options={[{ id: "tier1", label: "Tier 1" }, { id: "tier2", label: "Tier 2" }, { id: "tier3", label: "Tier 3" }]} />
              </Field>
              <Field label="Family members covered" hint={familyMembers}><SliderRow testid="hi-family" value={familyMembers} min={1} max={8} onChange={setFam} /></Field>
              <Field label="Age of eldest member" hint={eldestAge}><SliderRow testid="hi-age" value={eldestAge} min={18} max={85} suffix=" yr" onChange={setAge} /></Field>
              <Field label="Existing cover"><MoneyInput testid="hi-existing" value={existingCover} onChange={setExisting} helper={compactINR(existingCover)} /></Field>
            </div>
          </SectionCard>
        }
        right={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <StatCard testid="hi-recommended" label="Recommended Cover" value={compactINR(r.recommended)} accent="#D96B43" big />
              <StatCard testid="hi-topup" label="Additional Cover Needed" value={compactINR(r.topUpNeeded)} accent={r.topUpNeeded > 0 ? "#B45309" : "#2D6A4F"} sub={r.topUpNeeded > 0 ? "Consider a top-up" : "You're well covered"} />
            </div>
            <SectionCard title="How we estimate this">
              <InfoRow label="Base cover for city tier" value={compactINR(r.base)} />
              <InfoRow label="Family & age adjustments" value={compactINR(r.recommended - r.base)} />
              <InfoRow label="Recommended total" value={compactINR(r.recommended)} strong />
              <p className="text-xs text-[#8A9790] mt-3">Metro hospitalisation costs are higher, so Tier 1 needs more cover. Add a super top-up for large-ticket protection at low premium.</p>
            </SectionCard>
          </>
        }
      />
    </ToolLayout>
  );
}
